export default {
  functionKey: "COMMENCE PAR",
  title: "COMMENCE PAR",
  group: "Organisation",
  origin: [],
  arguments: [],
  target: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Prefix", name: "Préfixe" }],
  expectedArguments: [
    { name: "Préfixe", argumentKey: "Prefix", single: true, initialValue: "" }
  ],
  description: "Evalue si le texte d'origine commence par le texte de l'argument",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.startsWith(${args[0]});`;
    return { displayCode: code, safeCode: code };
  }
}
